import React from 'react';
import { ArrowTrendingUpIcon, ArrowTrendingDownIcon, MinusIcon } from '@heroicons/react/24/outline';
import { formatNumber } from '../../utils/statsFormat';

/**
 * Indicateur de tête : une valeur, et son évolution par rapport à la période précédente.
 * @param {string} label
 * @param {string} value - Valeur déjà mise en forme
 * @param {number|null} [evolution] - Évolution en %, null si non calculable
 * @param {boolean} [lowerIsBetter] - Une baisse est une bonne nouvelle (délai, taux de refus)
 * @param {string} [hint] - Précision sous la valeur
 */
const StatTile = ({ label, value, evolution, lowerIsBetter = false, hint }) => {
  const known = evolution !== null && evolution !== undefined;
  const flat = known && evolution === 0;
  const up = known && evolution > 0;
  const good = known && !flat && up !== lowerIsBetter;
  const Icon = !known || flat ? MinusIcon : up ? ArrowTrendingUpIcon : ArrowTrendingDownIcon;

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4">
      <p className="text-xs font-medium uppercase tracking-wide text-gray-500">{label}</p>
      <p className="mt-1 text-2xl font-semibold text-gray-900 tabular-nums">{value}</p>
      <div className="mt-1 flex items-center gap-1 text-xs">
        {known ? (
          <>
            <Icon className={`h-4 w-4 ${flat ? 'text-gray-400' : good ? 'text-green-700' : 'text-red-700'}`} aria-hidden="true" />
            <span className={`font-medium ${flat ? 'text-gray-500' : good ? 'text-green-700' : 'text-red-700'}`}>
              {up ? '+' : ''}{formatNumber(evolution, 1)} %
            </span>
            <span className="text-gray-500">vs période précédente</span>
          </>
        ) : (
          <span className="text-gray-400">{hint || 'Pas de période de comparaison'}</span>
        )}
      </div>
      {known && hint && <p className="mt-1 text-xs text-gray-500">{hint}</p>}
    </div>
  );
};

export default StatTile;
